import { BASE_URL } from "../apiConfig";
import { authFetch } from "../../utils/authFetch";

export async function transferApi({ sender, recipient, amount, contractRefId }) {
  try {
    const response = await authFetch(`${BASE_URL}/api/transfer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // optional if you add JWT later
         "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({ sender, recipient, amount, contractRefId}),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}`);
    }

    return data; // expected { success: true } or { success: false, error: "..." }
  } catch (error) {
    console.error("Transfer API error:", error);
    throw error;
  }
}
